<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">名称</span>
         <el-input v-model.trim="name" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">手机号</span>
        <el-input v-model.trim="phoneNumber" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getUserPageFn()">
          搜索
        </el-button>
		
		<el-button type="primary" @click="editBtn(5)">
		    一卡通云平台2.0会话token
		</el-button>
	
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="name" label="姓名"></el-table-column>
      <el-table-column align="center" prop="phoneNumber" label="手机号"></el-table-column>
      <el-table-column align="center" prop="registrationTime" label="登记时间"></el-table-column>
      <el-table-column align="center" prop="jobStatus" label="职务状态"></el-table-column>
	  <el-table-column align="center" prop="internalNumber" label="内部编号"></el-table-column>
	  
	  <el-table-column align="center"  label="图片">
	    <template slot-scope="{row}">
	      <el-image class="m-box-img" :src="row.faceName" @click="editBtn(4,row)" lazy></el-image>
	    </template>
	  </el-table-column>
	  
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="{row}">
        <!-- <a class="glob-a" @click="statusBtn(3, row)">查看</a> -->
        <!-- <a class="glob-a" @click="statusBtn(1, row)">{{row.openFlagValue === 'NONPROHIBITED' ? '禁用': '启用'}}</a> -->
        <!-- <a class="glob-a" @click="statusBtn(2, row)">广告权限</a> -->
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <!-- 账号状态设置 -->
    <el-dialog title="账号状态设置" :visible.sync="statusData.modal" width="550px">
      <el-form :model="statusData" label-width="120px">
        <el-form-item label="当前账号状态:">
          {{statusData.typeName}}
        </el-form-item>
        <el-form-item :label="statusData.type === 'PROHIBIT' ? '启用时间' : '禁用时间:'">
          <el-date-picker
              v-model="statusData.date"
              style="width: 300px;"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item label="禁用说明:" v-if="statusData.type === 'NONPROHIBITED'">
          <el-input
              type="textarea"
              :rows="5"
              style="width: 300px;"
              maxlength="100"
              resize="none"
              v-model="statusData.content"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="statusData.modal = false">取 消</el-button>
        <el-button type="primary" @click="statusSave">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 广告权限设置 -->
    <el-dialog title="广告权限设置" :visible.sync="adData.modal" width="500px">
      <el-row>
        <el-col :span="12" class="pl20">
          <el-checkbox :indeterminate="adData.adTypeIsIndeterminate"
                       v-model="adData.adTypeAll"
                       class="mb20"
                       @change="adTypeAllChange($event, 1)">
            全选 (禁止发布任何广告)
          </el-checkbox>
          <el-checkbox-group v-model="adData.adType" @change="adTypeChange($event, 1)">
            <el-checkbox class="dblock mb20" v-for="(item,index) in adTypeList" :label="item.value" :key="index">
              {{item.name}}
            </el-checkbox>
          </el-checkbox-group>
        </el-col>
        <el-col :span="12">
          <el-checkbox :indeterminate="adData.adPositionIsIndeterminate"
                       v-model="adData.adPositionAll"
                       class="mb20"
                       @change="adTypeAllChange($event, 2)">
            全选 (禁止投放任何广告)
          </el-checkbox>
          <el-checkbox-group v-model="adData.adPosition" @change="adTypeChange($event, 2)">
            <el-checkbox class="dblock mb20" v-for="(item,index) in adPositionList" :label="item.value" :key="index">
              {{item.name}}
            </el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>

      <div slot="footer">
        <el-button @click="adData.modal = false">取 消</el-button>
        <el-button type="primary" @click="adSave">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog title="查看" :visible.sync="detailModal" fullscreen>
      <detail :id="detailId"/>
    </el-dialog>

    <!-- 邀请好友设置 -->
    <el-dialog title="邀请好友设置" :visible.sync="friendData.modal" width="500px">
      <el-form label-width="120px">
        <el-form-item label="邀请人分成比例">
          <el-input v-model.trim="friendData.ratio" type="number" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="邀请规则">
          <el-input v-model.trim="friendData.content" type="textarea" :rows="5" resize="none" placeholder="请输入"/>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="friendData.modal = false">取 消</el-button>
        <el-button type="primary" @click="editSave(1)">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 新用户奖励 -->
    <el-dialog title="新用户奖励" :visible.sync="newUserData.modal" width="400px">
      <el-form label-width="150px">
        <el-form-item label="奖励购物金金额">
          <el-input v-model.trim="newUserData.value" type="number" placeholder="请输入"/>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="newUserData.modal = false">取 消</el-button>
        <el-button type="primary" @click="editSave(2)">确 定</el-button>
      </div>
    </el-dialog>
	
	<!-- 图片放大 -->
	<el-dialog title="查看" :visible.sync="imgPreData.modal" width="800px">
	  <img style="width: 100%; height: auto;" :src="imgPreData.url" alt="">
	</el-dialog>
	
	<!-- 一卡通云平台2.0会话token -->
	<el-dialog title="一卡通云平台2.0会话token" :visible.sync="oneCardSolutionDialog.modal"  width="400px">
	  <el-form label-width="320px">
	    <span class="pr5">会话token</span>
		<el-input v-model.trim="timeSetting"  placeholder="请输入"/>
	  </el-form>
	
	  <div slot="footer">
	    <el-button @click="oneCardSolutionDialog.modal = false">取 消</el-button>
	    <el-button type="primary" @click="getTransactionAndEntryTimeSetUpChangeFn()">确 定</el-button>
	  </div>
	</el-dialog>
	
  </div>
</template>

<script>
  import Detail from './Detail.vue'
  import {
    getNhUser,

    getUserPage,
    getAgentTree,
    getAreaTreeOnlyCityProvince,
    setUserStatus,
    getUserFriend,
    setUserFriend,
    getUserNewUserRule,
    setUserNewUserRule,
    getUserAdAuth,
    setUserAdAuth,
	
	getTransactionAndEntryTimeSetUpSee,
	getTransactionAndEntryTimeSetUpChange
	
  } from '@/api'

   import WordImg from '@/components/WordImg.vue'

  export default {
    name: 'UserList',	
    components: {Detail,WordImg},
    data () {
      return {
        date: [],
        status: '',
        city: [],
        cityList: [],
        agent: '',
        agentList: [],
        name: '',
        phoneNumber: '',
        tableData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        // 详情
        detailId: '',
        detailModal: false,
        // 状态
        statusData: {
          modal: false,
          userId: '',
          type: '',
          typeName: '',
          date: [],
          content: ''
        },
        // 广告权限
        adData: {
          modal: false,
          userId: '',
          adTypeAll: false,
          adType: [],
          adTypeIsIndeterminate: false,
          adPositionAll: false,
          adPosition: [],
          adPositionIsIndeterminate: false,
        },
        adTypeList: [
          {name: '禁止发布通用广告', value: 'NORMAL'},
          {name: '禁止发布商品广告', value: 'GOODS'},
          {name: '禁止发布视频广告', value: 'VIDEO'},
          {name: '禁止发布外链广告', value: 'OUT_LINK'},
        ],
        adPositionList: [
          {name: '禁止投放列表', value: 'LIST'},
          {name: '禁止投放内容', value: 'CONTENT'},
          // {name: '禁止投放详情', value: 'DETAIL'},
        ],
        // 邀请好友设置
        friendData: {
          modal: false,
          ratio: '',
          content: ''
        },
        // 新用户奖励
        newUserData: {
          modal: false,
          value: ''
        },
		// 图片放大
		imgPreData: {
		  modal: false,
		  url: ''
		},
		//会话token
		timeSetting:'',
		//一卡通云平台2.0会话token
		 oneCardSolutionDialog: {
		   modal: false,
		   ratio: '',
		   content: ''
		 }
      }
    },
    created () {
      this.getUserPageFn()
      //this.getAgentTreeFn()
      //this.getAreaTreeOnlyCityProvinceFn()
    },
    methods: {
      adSave () {
        this.adData.modal = false
        setUserAdAuth({
          userId: this.adData.userId,
          adType: this.adData.adType,
          adPosition: this.adData.adPosition
        }).then(res => {
          this.$message.success(res.data)
          this.adData.modal = false
          this.getUserPageFn()
        })
      },
      adTypeAllChange (val, t) {
        if (t === 1) {
          this.adData.adType = val ? this.adTypeList.map(item => item.value) : []
          this.adData.adTypeIsIndeterminate = false
        } else {
          this.adData.adPosition = val ? this.adPositionList.map(item => item.value) : []
          this.adData.adPositionIsIndeterminate = false
        }
      },
      adTypeChange (value, t) {
        if (t == 1) {
          let checkedCount = value.length
          this.adData.adTypeAll = checkedCount === this.adTypeList.length
          this.adData.adTypeIsIndeterminate = checkedCount > 0 && checkedCount < this.adTypeList.length
        } else {
          let checkedCount = value.length
          this.adData.adPositionAll = checkedCount === this.adPositionList.length
          this.adData.adPositionIsIndeterminate = checkedCount > 0 && checkedCount < this.adPositionList.length
        }
      },
      editSave (t) {
        switch (t) {
          case 1:
            setUserFriend({
              proportion: this.friendData.ratio,
              ruleDescription: this.friendData.content,
            }).then(res => {
              this.$message.success(res.data)
              this.friendData.modal = false
            })
            break
          case 2:
            setUserNewUserRule(this.newUserData.value).then(res => {
              this.$message.success(res.data)
              this.newUserData.modal = false
            })
            break
        }
      },
      // t: 1邀请好友设置 2新用户奖励 4图片放大查看
      editBtn (t,row) {
        switch (t) {
          case 1:
            getUserFriend().then(res => {
              this.friendData = {
                modal: true,
                ratio: res.data.propertyValue,
                content: res.data.propertyDesc
              }
            })
            break
          case 2:
            getUserNewUserRule().then(res => {
              this.newUserData = {
                modal: true,
                value: res.data
              }
            })
            break
		   case 4:
		   this.imgPreData = {
		     modal: true,
		     url: row.faceName
		   }
			break
			case 5:
			//交易流水统计早中晚合计笔数合计金额
			  this.oneCardSolutionDialog = {
			        modal: true,
			        ratio: '',
			        content: ''
			      }
			this.getTransactionAndEntryTimeSetUpSeeFn();
			break
        }
      },
	  //一卡通云平台2.0会话token
	    getTransactionAndEntryTimeSetUpSeeFn(){
	      this.tableLoading = true
	      getTransactionAndEntryTimeSetUpSee({id:'9fc2a64e01384d1f8d322289dac91a64'}).then(res => {
	        this.timeSetting = res.data;
	      }).finally(() => {
	        this.tableLoading = false
	      })
	    },
	  //一卡通云平台2.0会话token 改变
	  getTransactionAndEntryTimeSetUpChangeFn(){
	    this.tableLoading = true
	    getTransactionAndEntryTimeSetUpChange({id:'9fc2a64e01384d1f8d322289dac91a64',time:this.timeSetting}).then(res => {
	      if(res.data){
	         this.oneCardSolutionDialog = {
	            modal: false,
	            ratio: '',
	            content: ''
	          }
	      }
	    }).finally(() => {
	      this.tableLoading = false
	    })
	  },
      statusSave () {
        setUserStatus({
          userId: this.statusData.userId,
          openFlag: this.statusData.type === 'NONPROHIBITED' ? 'PROHIBIT' : 'NONPROHIBITED',
          frozenStartTime: this.statusData.date && this.statusData.date.length ? this.statusData.date[0] : '',
          frozenExpiryTime: this.statusData.date && this.statusData.date.length > 1 ? this.statusData.date[1] : '',
          frozenReason: this.statusData.content,
        }).then(res => {
          this.$message.success(res.data)
          this.statusData.modal = false
          this.getUserPageFn()
        })
      },
      // t: 1切换状态 2广告权限 3查看
      statusBtn (t, row) {
        if (t == 1) {
          this.statusData = {
            modal: true,
            userId: row.userId,
            type: row.openFlagValue,
            typeName: row.openFlag,
            date: [],
            content: ''
          }
        } else if (t == 2) {
          getUserAdAuth(row.userId).then(res => {
            this.adData.modal = true
            this.adData.userId = row.userId
            this.adData.adType = res.data.adType
            this.adData.adPosition = res.data.adPosition

            this.adTypeChange(res.data.adType, 1)
            this.adTypeChange(res.data.adPosition, 2)
          })
        } else {
          this.detailModal = true
          this.detailId = row.userId
        }
      },
      getUserPageFn () {
        this.tableLoading = true
        getNhUser({
          pageNum: this.pages.page,
          name: this.name,
          phoneNumber: this.phoneNumber
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getUserPageFn()
      },
      getAgentTreeFn () {
        getAgentTree().then(res => {
          this.agentList = res.data
        })
      },
      getAreaTreeOnlyCityProvinceFn () {
        getAreaTreeOnlyCityProvince().then(res => {
          this.cityList = res.data
        })
      }
    }
  }
</script>

<style scoped>

</style>
